module.exports = __webpack_public_path__ + "static/media/logo.752ff234.png";